export const INVALID_EMAIL_ID = "Invalid email ID entered";
export const EMPTY_INPUT = "should not be empty";
export const INVALID_LENGTH_TITLE_INPUT = "must be less than 60 character";
export const INVALID_LENGTH_BODY_INPUT = "must be less than 200 character";
export const INVALID_LENGTH_LABEL_INPUT = "must be less than 50 character";
export const PASSWORD_AND_CONFIRMPASSWORD = `Password and confirm password should \n be same`;
export const PASSWORD_CONSTRAINTS_MESSAGE = `Your password must be greater than \n 8 digits at least 1 uppercase & 1 \n lowercase character,1 number and  \n a special character`;
export const INVALID_ENTRY = "Invalid entry!!";
export const PASSWORD_AND_OLDPASSWORD = `Current password and New password should \n not be same`;

